import { getAdminMinuteProgramEnrollmentsListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";
import { listParamsForPage } from "./params";

type QueriesInput = { search: { page: number } };

export const enrollmentsQuery = ({ search }: QueriesInput) =>
  getAdminMinuteProgramEnrollmentsListQueryOptions(listParamsForPage(search.page));

export const queries = (input: QueriesInput): Array<WarmableQuery> => [enrollmentsQuery(input)];
